import React from 'react';

import useDimensions from './ElementDimensions';

interface ResizeProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
}
const ResizeHeight = (props: ResizeProps) => {
  const { id, className, children } = props;
  const [ref, elemSize] = useDimensions();
  const documnetHeight = document.documentElement.clientHeight;

  return (
    <div ref={ref} style={{ height: `calc(${documnetHeight}px - ${elemSize && elemSize.top}px)`, width: '100%' }} id={id} className={className}>
      {children}
    </div>
  );
};

export default ResizeHeight;
